module.exports = __webpack_public_path__ + "static/media/ic-invoice.40a29f86.svg";